import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { threeDSWarningFlag as threeDSWarningFlagSelector } from 'ggApp/modules/featureFlag/selectors';
import CreditCardForm from './CreditCardForm';

const enhance = compose(
    connect(
        createStructuredSelector({
            threeDSWarningFlag: threeDSWarningFlagSelector,
        }),
    ),
);

export default enhance(CreditCardForm);
